/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TeamMemberRole = "Admin" | "Member" | "%future added value";
export type TeamJoinCreate_viewer = {
    readonly user: {
        readonly id: string;
    } | null;
    readonly id: string;
    readonly teamQueryResultErrorable: {
        readonly query?: string | undefined;
        readonly teams?: ReadonlyArray<{
            readonly teamName: string;
            readonly teamId: string;
            readonly teamRoleAndPersonIds: ReadonlyArray<{
                readonly role: TeamMemberRole;
                readonly personId: string;
            }>;
        }> | undefined;
        readonly teamMembers?: ReadonlyArray<{
            readonly role: TeamMemberRole;
            readonly person: {
                readonly personId: string;
                readonly primaryCalendarId: string;
                readonly isYou: boolean;
                readonly profile: {
                    readonly givenName: string | null;
                    readonly familyName: string | null;
                } | null;
                readonly " $fragmentRefs": FragmentRefs<"AvatarPerson_orgPerson">;
            };
        }> | undefined;
    };
    readonly " $fragmentRefs": FragmentRefs<"TeamSettingsSearch_viewer">;
    readonly " $refType": "TeamJoinCreate_viewer";
};
export type TeamJoinCreate_viewer$data = TeamJoinCreate_viewer;
export type TeamJoinCreate_viewer$key = {
    readonly " $data"?: TeamJoinCreate_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TeamJoinCreate_viewer">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v1 = {
        "kind": "Variable",
        "name": "orgRelayId",
        "variableName": "orgRelayId"
    } as any, v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "role",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "personId",
        "storageKey": null
    } as any;
    return {
        "argumentDefinitions": [
            {
                "defaultValue": true,
                "kind": "LocalArgument",
                "name": "excludeMyTeams"
            },
            {
                "defaultValue": [],
                "kind": "LocalArgument",
                "name": "myCalendarIds"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "orgRelayId"
            },
            {
                "defaultValue": "",
                "kind": "LocalArgument",
                "name": "query"
            }
        ],
        "kind": "Fragment",
        "metadata": null,
        "name": "TeamJoinCreate_viewer",
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    (v0 /*: any*/)
                ],
                "storageKey": null
            },
            (v0 /*: any*/),
            {
                "alias": null,
                "args": [
                    {
                        "kind": "Variable",
                        "name": "excludeMyTeams",
                        "variableName": "excludeMyTeams"
                    },
                    (v1 /*: any*/),
                    {
                        "kind": "Variable",
                        "name": "query",
                        "variableName": "query"
                    }
                ],
                "concreteType": null,
                "kind": "LinkedField",
                "name": "teamQueryResultErrorable",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "query",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "Team",
                                "kind": "LinkedField",
                                "name": "teams",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "teamName",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "teamId",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TeamRoleAndPersonId",
                                        "kind": "LinkedField",
                                        "name": "teamRoleAndPersonIds",
                                        "plural": true,
                                        "selections": [
                                            (v2 /*: any*/),
                                            (v3 /*: any*/)
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "TeamMember",
                                "kind": "LinkedField",
                                "name": "teamMembers",
                                "plural": true,
                                "selections": [
                                    (v2 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "OrgPerson",
                                        "kind": "LinkedField",
                                        "name": "person",
                                        "plural": false,
                                        "selections": [
                                            (v3 /*: any*/),
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "primaryCalendarId",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "isYou",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "UserProfile",
                                                "kind": "LinkedField",
                                                "name": "profile",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "givenName",
                                                        "storageKey": null
                                                    },
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "familyName",
                                                        "storageKey": null
                                                    }
                                                ],
                                                "storageKey": null
                                            },
                                            {
                                                "args": null,
                                                "kind": "FragmentSpread",
                                                "name": "AvatarPerson_orgPerson"
                                            }
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "type": "TeamQueryResult",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "excludeCalendars",
                        "variableName": "myCalendarIds"
                    },
                    (v1 /*: any*/)
                ],
                "kind": "FragmentSpread",
                "name": "TeamSettingsSearch_viewer"
            }
        ],
        "type": "Viewer",
        "abstractKey": null
    } as any;
})();
(node as any).hash = 'bb359f58991403a66569685b34f28a02';
export default node;
